import { Tooltip } from '@mui/material'
import { FC } from 'react'
import { OptionToggleSwitch } from './OptionToggleSwitch'

type Props = {
  /** 非活性の理由。ホバー時に Tooltip で表示する */
  tooltip: string
  label: string
  /** 現在の設定値。非活性でも実際の値を表示する（既存データで ON のまま非活性になる場合がある） */
  isChecked: boolean
}

/**
 * 非活性のトグル。
 * disabled な要素はホバーイベントを受けられないため、span で一段ラップして Tooltip を効かせる。
 */
const DisabledSwitch: FC<Props> = ({ tooltip, label, isChecked }) => (
  <Tooltip placement="top" title={tooltip}>
    <span>
      <OptionToggleSwitch
        isChecked={isChecked}
        onChange={() => undefined}
        label={label}
        isDisabled
      />
    </span>
  </Tooltip>
)

export default DisabledSwitch
